import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { hexify } from '../../utils';
import {
  getAnnouncements,
} from '../../../../consumer_web/app/modules/containers/AnnouncementContainer/AnnouncementAPI';
import AnnouncementTileContentAndCta from './AnnouncementTileContentAndCta';
import './AnnouncementTile.scss';
import useSessionStorage from './useSessionStorage';
import Logger from '../../utils/logger';
import { EVENT_TYPE } from '../Announcement/announcementTypes';

const TILE_TYPE = 'tile';
const ANNOUNCEMENT_LOADED = 'Announcement displayed';
const ANNOUNCEMENT_CLICKED = 'Announcement clicked';
const CACHE_KEY = 'announcementTileCounter';

const AnnouncementTile = (props) => {
  const {
    Analytics, flowContext, locationCode, matchMedia, deviceId,
  } = props;

  // hooks
  const [tile, setTile] = useState();
  const [titleText, setTitleText] = useState();
  const [counter, setCounter] = useSessionStorage(CACHE_KEY, 0);

  // tracking
  const trackEvent = (eventName, flowContext) => (title) => { // eslint-disable-line no-shadow
    if (eventName === ANNOUNCEMENT_LOADED) {
      Analytics.event(EVENT_TYPE.VIEW_ANNOUNCEMENT, {
        title,
        context: flowContext.replaceAll('_', '-'),
        type: TILE_TYPE,
        id: tile.id,
      });
    } else {
      Analytics.event(EVENT_TYPE.CLICK_ANNOUNCEMENT, {
        context: flowContext.replaceAll('_', '-'),
        type: TILE_TYPE,
        title,
        id: tile.id,
        cta: 'primary',
      });
    }
  };
  const trackLoadEvent = trackEvent(ANNOUNCEMENT_LOADED, flowContext);
  const trackClickEvent = trackEvent(ANNOUNCEMENT_CLICKED, flowContext);

  useEffect(() => {
    if (titleText) {
      trackLoadEvent(titleText);
    }
  }, [titleText]);

  useEffect(() => {
    /* eslint-disable-next-line no-shadow */
    const fetchAnnouncements = (deviceId, locationCode, flowContext) => {
      getAnnouncements({ deviceId, locationCode, flowContext })
        .then((response) => {
          const normalizedResponse = response == null ? [] : response;
          const tiles = normalizedResponse.filter((item) => item.display.web.type === TILE_TYPE);
          const len = tiles.length;
          /* istanbul ignore else */
          if (len > 0) {
            const index = counter % len;
            setTile(tiles[index]);
            setTitleText(tiles[index]?.display?.title);
            setCounter((c) => c + 1);
          }
        })
        .catch((err) => Logger.error(err));
    };
    /* istanbul ignore else */
    if (deviceId && locationCode && flowContext) {
      fetchAnnouncements(deviceId, locationCode, flowContext);
    }
  }, [deviceId, locationCode, flowContext]);

  // render
  if (!tile) {
    return null;
  }
  const announcementTileContentAndCta = (
    <AnnouncementTileContentAndCta
      action={tile.action}
      secondary_action={tile.secondary_action}
      trackClick={trackClickEvent}
      {...tile.display}
    />
  );
  const {
    title, image, heading, color_dict: colorDict,
  } = tile.display;
  return (
    <div className="AnnouncementTile__tile-container">
      <div>
        <img
          alt={title}
          className="AnnouncementTile__tile-image"
          src={image}
          tabIndex={-1}
        />
        <div className="AnnouncementTile__tile-text">
          <div
            className="AnnouncementTile__tile-text--heading"
            style={{ color: hexify(colorDict.header_text) }}
          >
            {heading}
          </div>
          <div
            className="AnnouncementTile__tile-text--title"
            style={{ color: hexify(colorDict.title_text) }}
          >
            {title}
          </div>
          {matchMedia.sm && announcementTileContentAndCta}
        </div>
      </div>
      {!matchMedia.sm && announcementTileContentAndCta}
    </div>
  );
};

AnnouncementTile.propTypes = {
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  locationCode: PropTypes.string.isRequired,
  flowContext: PropTypes.string,
  deviceId: PropTypes.string.isRequired,
};

AnnouncementTile.defaultProps = {
  flowContext: undefined,
};

export default AnnouncementTile;
